import React from "react";
import cn from "classnames";
import PropTypes from "prop-types";
import Icon from "components/icon";
import { DataGridItem } from "components/data-grid";
import Button from "components/buttons";
import withStyles from "components/with-styles";
import { FormattedMessage } from "react-intl";
import styles from "./styles/add-subform-button.css.js";

const AddSubformButton = ({ text, classes, onClick, className }) => {
  return (
    <DataGridItem className={cn(className, classes.root)} big>
      <Button onClick={onClick} variant="outlined" size="small">
        <Icon name="add" className={cn(classes.leftIcon, classes.iconSmall)} />
        {text ? text : <FormattedMessage id="common.add" />}
      </Button>
    </DataGridItem>
  );
};

AddSubformButton.propTypes = {
  /**
   * Texto del botón
   **/
  text: PropTypes.string,
  /**
   * Clase adicional del componente
   **/
  className: PropTypes.string,
  /**
   * Callback a usar al hacer clic en el botón
   **/
  onClick: PropTypes.func,
};

export default withStyles(styles)(AddSubformButton);
